/* react/no-unescaped-entities */
import React, { useEffect, useState, useContext } from 'react';
import { AuthContext } from '@xometry/auth-context';
import { Flex, theme, Link, Box, Spinner } from '@xometry/xometry_loft';
import { css } from '@emotion/react';
import SupplierCapabilitiesForm from './SupplierCapabilitiesForm';
import Processes from '../../../services/Processes';
import Companies from '../../../services/Companies';
import { getPrimaryPartnerId } from '../../../utils/helpers';

const SupplierCapabilities = () => {
  const { isLoading, user } = useContext(AuthContext);

  if (isLoading) return <Spinner />;
  if (!user) {
    window.location.assign('/login');
  }

  const [data, setData] = useState({
    error: null,
    isLoaded: false,
    processes: [],
    company: {},
  });

  useEffect(() => {
    const partnerId = getPrimaryPartnerId(user);
    if (!partnerId) {
      window.location.href = '/account/register-supplier';
      return;
    }

    Promise.all([
      Processes.get(null, { params: { quotable: true } }).then((procs) =>
        Processes.groupByType(procs)
      ),
      Companies.get(partnerId),
    ])
      .then(([processes, company]) => {
        setData({ isLoaded: true, processes, company });
      })
      .catch((error) => {
        setData({ error, isLoaded: true });
      });
  }, []);

  const { error, isLoaded, processes, company } = data;

  const submitForm = (values) => {
    return Companies.update(company.partner_id, {
      ...values,
      _etag: company._etag,
      _id: company._id,
    })
      .then(() => window.location.assign('/account/supplier/onboarding'))
      .catch((err) => console.error(err));
  };

  if (error)
    return (
      <div css="width: 600px; margin: 2rem auto;">
        <Box
          css={`
            border: 0;
            padding: 20px 20px;
          `}
        >
          <h5>
            This page is currently unable to load. Please try again later.
          </h5>
        </Box>
      </div>
    );

  if (!isLoaded) return <Spinner />;

  return (
    <Flex
      boxShadow="0px 1px 4px rgba(37, 56, 66, 0.2)"
      backgroundColor={theme.colors.white}
      margin="0 auto"
      width={['550px', '633px']}
      marginTop="40px"
      flexDirection="column"
    >
      <Box textAlign="center">
        <h3
          css={css`
            color: ${theme.colors.darkBlues[100]};
            font-weight: ${theme.fontWeights.regular};
            font-size: 28px;
            font-family: 'Open Sans';
            font-style: normal;
            margin-top: 0px;
            padding-top: 24px;
            margin-bottom: 0px;
            line-height: 36px;

            ${theme.mediaQueries.small} {
              font-size: 28px;
              margin-top: initial;
            }
          `}
        >
          Supported Processes
        </h3>
      </Box>
      <Box textAlign="center">
        <Box
          color={theme.colors.darkBlues[75]}
          fontWeight={theme.fontWeights.regular}
          fontFamily={theme.fonts[0]}
          fontSize={theme.fontSizes[0]}
          lineHeight={theme.lineHeights[2]}
          marginTop="8px"
          textAlign="center"
        >
          <Box textAlign="center">
            Listed below are the processes that we are actively onboarding into
            the Xometry
          </Box>
          <Box textAlign="center">
            Partner Network.{' '}
            <Link href="">Learn More about Xometry's supported processes.</Link>
          </Box>
        </Box>
      </Box>
      <SupplierCapabilitiesForm
        processes={processes}
        initialValues={{ supported_processes: [] }}
        onSubmit={submitForm}
      />
      <Box
        fontWeight={theme.fontWeights.regular}
        color={theme.colors.darkBlues[90]}
        fontSize={theme.fontSizes[0]}
        lineHeight={theme.lineHeights[2]}
        marginTop="32px"
        marginBottom="24px"
        display="flex"
        alignItems="center"
        justifyContent="center"
        textAlign="center"
      >
        If none of these match your shop's capabilities, create a free listing
        on Thomas.
        {/* <Link href="" marginLeft=".2rem">
          Thomas
        </Link>
        . */}
      </Box>
    </Flex>
  );
};

export default SupplierCapabilities;
